import {EntityIndicador} from './entity-indicador.model';
import {actions} from '~utils/ngrx-util';

const entityName = 'EntityIndicador';
const {add, adds, upsert, upserts, update, updates, remove, removes, load, clear} = actions<EntityIndicador>(entityName);
export const addEntityIndicador = add;
export const addEntityIndicadores = adds;
export const upsertEntityIndicador = upsert;
export const upsertEntityIndicadores = upserts;
export const updateEntityIndicador = update;
export const updateEntityIndicadores = updates;
export const deleteEntityIndicador = remove;
export const deleteEntityIndicadores = removes;
export const loadEntityIndicadores = load;
export const clearEntityIndicadores = clear;
